import { Search } from "lucide-react";

export const SearchBox = ({ value, onChange, testId, placeholder }) => (
  <div className="relative">
    <Search className="pointer-events-none absolute left-2.5 top-2.5 h-4 w-4 text-slate-500" />
    <input
      data-testid={testId}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="h-9 w-56 rounded-md border border-slate-700 bg-[#182232] pl-8 pr-3 text-sm text-slate-100 outline-none transition-colors focus:border-sky-500"
    />
  </div>
);

export const Chips = ({ options, value, onChange, testPrefix }) => (
  <div className="flex flex-wrap gap-1">
    {options.map((o) => (
      <button
        key={o}
        data-testid={`${testPrefix}-${o.toLowerCase()}`}
        onClick={() => onChange(o)}
        className={`rounded-md border px-2.5 py-1.5 font-mono text-[11px] uppercase tracking-wider transition-colors ${
          value === o ? "border-sky-500 bg-sky-600/20 text-sky-300" : "border-slate-700 text-slate-400 hover:border-slate-500 hover:text-slate-200"
        }`}
      >
        {o}
      </button>
    ))}
  </div>
);
